<template>
  <div v-if="serviceOrder" class="container">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <div class="header">
      <Message
        severity="error"
        :closable="false"
        icon="pi-exclamation-triangle"
        v-if="serviceOrder.pat_id && !serviceOrder.accepted"
      >
        <span class="p-d-flex p-ai-center p-jc-between">
          <span>Ordem de Serviço não foi Aceite</span>
          <Button
            label="Aceitar"
            icon="pi pi-check-circle"
            class="p-button-sm p-button-info"
            @click="createPatAcceptService"
            v-if="can('acceptServiceOrder')"
          />
        </span>
      </Message>
      <Message
        severity="error"
        :closable="false"
        icon="pi-exclamation-triangle"
        v-if="!serviceOrder.pat_id"
      >
        <span class="p-d-flex p-ai-center p-jc-between">
          <span> Pat da Ordem de Serviço não está Criado </span>
          <Button
            label="Criar"
            icon="pi pi-check-circle"
            class="p-button-sm p-button-info"
            @click="createPatAcceptService"
            v-if="can('createPatFromServiceOrder')"
          />
        </span>
      </Message>
    </div>
    <div class="content">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="service_receipt_no"
              name="service_receipt_no"
              type="text"
              v-model="serviceOrder.service_receipt_no"
              :disabled="true"
            />
            <label for="service_receipt_no">Referência</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="accepted"
              name="accepted"
              type="text"
              v-model="serviceOrder.accepted"
              :disabled="true"
            />
            <label for="accepted">Aceite</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="pat_id"
              name="pat_id"
              type="text"
              v-model="serviceOrder.pat_id"
              :disabled="true"
            />
            <label for="pat_id">PAT</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="receipt_date"
              name="receipt_date"
              type="text"
              v-model="serviceOrder.receipt_date"
              :disabled="true"
            />
            <label for="receipt_date">Data de Receção</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="request_date"
              name="request_date"
              type="text"
              v-model="serviceOrder.request_date"
              :disabled="true"
            />
            <label for="request_date">Data da Solicitação</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="promise_date"
              name="promise_date"
              type="text"
              v-model="serviceOrder.promise_date"
              :disabled="true"
            />
            <label for="promise_date">Data Prometida</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="svc_status_code"
              name="svc_status_code"
              type="text"
              v-model="serviceOrder.svc_status_code"
              :disabled="true"
            />
            <label for="svc_status_code">Código de Estado SVC</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="contact_name"
              name="contact_name"
              type="text"
              v-model="serviceOrder.contact_name"
              :disabled="true"
            />
            <label for="contact_name">Nome do Contacto</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="contact_phone_no"
              name="contact_phone_no"
              type="text"
              v-model="serviceOrder.contact_phone_no"
              :disabled="true"
            />
            <label for="contact_phone_no">Telefone do Contacto</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="phone1"
              name="phone1"
              type="text"
              v-model="serviceOrder.phone1"
              :disabled="true"
            />
            <label for="phone1">Telefone 1</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="phone2"
              name="phone2"
              type="text"
              v-model="serviceOrder.phone2"
              :disabled="true"
            />
            <label for="phone2">Telefone 2</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="contact_email"
              name="contact_email"
              type="text"
              v-model="serviceOrder.contact_email"
              :disabled="true"
            />
            <label for="contact_email">Email do Contacto</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="address_line1"
              name="address_line1"
              type="text"
              v-model="serviceOrder.address_line1"
              :disabled="true"
            />
            <label for="address_line1">Morada Linha 1</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="address_line2"
              name="address_line2"
              type="text"
              v-model="serviceOrder.address_line2"
              :disabled="true"
            />
            <label for="address_line2">Morada Linha 2</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="postal_code"
              name="postal_code"
              type="text"
              v-model="serviceOrder.postal_code"
              :disabled="true"
            />
            <label for="postal_code">Código Postal</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="city_name"
              name="city_name"
              type="text"
              v-model="serviceOrder.city_name"
              :disabled="true"
            />
            <label for="city_name">Localidade</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="state_name"
              name="state_name"
              type="text"
              v-model="serviceOrder.state_name"
              :disabled="true"
            />
            <label for="state_name">Estado</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="service_product_code"
              name="service_product_code"
              type="text"
              v-model="serviceOrder.service_product_code"
              :disabled="true"
            />
            <label for="service_product_code">Código Equipamento</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="brand_code"
              name="brand_code"
              type="text"
              v-model="serviceOrder.brand_code"
              :disabled="true"
            />
            <label for="brand_code">Código da Marca do Equipamento</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="model_code"
              name="model_code"
              type="text"
              v-model="serviceOrder.model_code"
              :disabled="true"
            />
            <label for="model_code">Código do Modelo do Equipamento</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="serial_no"
              name="serial_no"
              type="text"
              v-model="serviceOrder.serial_no"
              :disabled="true"
            />
            <label for="serial_no">Número de Série</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="service_product_code"
              name="service_product_code"
              type="text"
              v-model="serviceOrder.service_product_code"
              :disabled="true"
            />
            <label for="service_product_code"
              >Código do Produto de Serviço</label
            >
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="warranty_flag"
              name="warranty_flag"
              type="text"
              v-model="serviceOrder.warranty_flag"
              :disabled="true"
            />
            <label for="warranty_flag">Tipo de Garantia</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="purchase_date"
              name="purchase_date"
              type="text"
              v-model="serviceOrder.purchase_date"
              :disabled="true"
            />
            <label for="purchase_date">Data de Compra</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <Textarea
              id="receipt_symptom_desc"
              name="receipt_symptom_desc"
              type="text"
              v-model="serviceOrder.receipt_symptom_desc"
              :disabled="true"
              :autoResize="true"
            />
            <label for="receipt_symptom_desc"
              >Descrição do Sintoma do Recibo</label
            >
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <Textarea
              id="detail_symptom_desc"
              name="detail_symptom_desc"
              type="text"
              v-model="serviceOrder.detail_symptom_desc"
              :disabled="true"
              :autoResize="true"
            />
            <label for="detail_symptom_desc"
              >Descrição do Sintoma Detalhado</label
            >
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <Textarea
              id="receipt_detail"
              name="receipt_detail"
              type="text"
              v-model="serviceOrder.receipt_detail"
              :disabled="true"
              :autoResize="true"
            />
            <label for="receipt_detail">Detalhe na Receção</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <Textarea
              id="product_symptom_desc"
              name="product_symptom_desc"
              type="text"
              v-model="serviceOrder.product_symptom_desc"
              :disabled="true"
              :autoResize="true"
            />
            <label for="product_symptom_desc"
              >Descrição dos Dintomas do Produto</label
            >
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="service_type_code"
              name="service_type_code"
              type="text"
              v-model="serviceOrder.service_type_code"
              :disabled="true"
            />
            <label for="service_type_code">Código do Tipo de Serviço</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_type_code"
              name="customer_type_code"
              type="text"
              v-model="serviceOrder.customer_type_code"
              :disabled="true"
            />
            <label for="customer_type_code">Código do Tipo de Cliente</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="special_customer_type_code"
              name="special_customer_type_code"
              type="text"
              v-model="serviceOrder.special_customer_type_code"
              :disabled="true"
            />
            <label for="special_customer_type_code"
              >Código de Cliente Especial</label
            >
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="svc_engr_forwarding_content"
              name="svc_engr_forwarding_content"
              type="text"
              v-model="serviceOrder.svc_engr_forwarding_content"
              :disabled="true"
            />
            <label for="svc_engr_forwarding_content"
              >Código de Cliente Especial</label
            >
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="dealer_receipt_no"
              name="dealer_receipt_no"
              type="text"
              v-model="serviceOrder.dealer_receipt_no"
              :disabled="true"
            />
            <label for="dealer_receipt_no">Nº do Recibo do Revendedor</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="priority_flag"
              name="priority_flag"
              type="text"
              v-model="serviceOrder.priority_flag"
              :disabled="true"
            />
            <label for="priority_flag">Prioridade</label>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import serviceOrdersService from "../../services/serviceOrders.service";
export default {
  name: "DetailLG",
  props: ["serviceOrder"],
  methods: {
    createPatAcceptService() {
      return serviceOrdersService
        .createPatAcceptService(this.serviceOrder.id)
        .then((response) => {
          if (response.error !== undefined) {
            return this.$toast.add({
              severity: "error",
              summary: `Ocorreu um erro`,
              detail: response.error,
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Ordem Serviço Atualizada`,
            detail: "",
            life: 3000,
          });
          return this.$emit("createPatAcceptService", response);
        });
    },
  },
};
</script>
<style>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  overflow: auto;
  padding: 10px;
}
</style>
<style lang="css" scoped>
:deep(.p-message-text) {
  width: 100% !important;
}
</style>
